export default {
  surveyBuilder: {
    addNewSurvey: "Agregar Nuevo Cuestionario",
    surveyTitle: "Título del Cuestionario",
    surveyName: "Nombre del Cuestionario",
    surveyDescription: "Descripción del Cuestionario",
    describeSurvey: "Describir el Cuestionario",
    enableScheduling: "Habilitar Programación",
    enableSchedulingInfo: "Capacidad para establecer una fecha u hora específica para la evaluación.",
    selectedDate: "Fecha Seleccionada",
    multiStepSurvey: "Cuestionario de Múltiples Pasos",
    multiStepSurveyDetails:
      "Según la cantidad de preguntas en cada paso, todas las preguntas en el cuestionario se agruparán y mostrarán por pasos.",
    multiStep: "Múltiples Pasos",
    noQuestionEachStep: "Número de Preguntas en Cada Paso",
    surveyStatus: "Estado del Cuestionario",
    surveyStatusDetails:
      "El cuestionario solo se puede habilitar después de agregar preguntas. Habilitar el cuestionario permitirá que los agricultores comiencen a enviar sus respuestas.",
    selectUsers: "Seleccionar Usuarios",
    selectUsersDetails:
      "Si deshabilitas la selección de usuarios, el cuestionario estará disponible para todos los usuarios. Si habilitas la selección de usuarios, podrás elegir múltiples usuarios en el siguiente paso.",
    linkWithFarms: "Vincular con Fincas",
    linkWithFarmsDetails:
      "Si está habilitado, el cuestionario se vinculará con fincas individuales. Si un agricultor tiene varias fincas, cada finca tendrá su propio cuestionario.",
    enabled: "Habilitado",
    disabled: "Deshabilitado",
    cancel: "Cancelar",
    next: "Siguiente",
    surveySettings: "Configuración del Cuestionario",

    selectSurveyUsers: "Seleccionar Usuarios de la Encuesta",
    selectToProceed: "Por favor, seleccione usuario(s) para continuar",
    searchUsers: "Buscar Usuarios",
    usersSelected: "Usuarios Seleccionados",
    conditional: "Condicional",
    autoConditional: "Automático Condicional",
    userName: "Nombre de Usuario",
    email: "Correo Electrónico",
    membershipType: "Tipo de Membresía",
    membershipValidity: "Validez de la Membresía",
    membershipRemainingDays: "Número de Días Restantes",
    membershipRole: "Rol del Miembro",
    accountProgress: "Progreso de la Cuenta",
    status: "Estado",
    active: "Activo",
    inactive: "Inactivo",
    deactivated: "Desactivado",
    continue: "Continuar",
    questions: "Preguntas",
    questionInfo: "El texto de la pregunta de evaluación que se presentará al encuestado.",
    responses: "Respuestas",
    deleteSurvey: "Eliminar Encuesta",
    editSurvey: "Editar Encuesta",
    type: "Tipo",
    typeInfo: "Un menú desplegable para especificar el tipo de entrada requerida para la pregunta, como botón de opción, casilla de verificación o entrada de texto.",
    compulsory: "Obligatorio",
    createSurvey: "Crear Encuesta",
    surveyBuilder: "Constructor de Encuestas",
    surveyList: "Lista de Encuestas",
    farm: "Finca",
    responseDate: "Fecha de Respuesta",
    viewSurvey: "Ver Encuesta",
    question: "Pregunta",
    settings: "Configuración",
    addQuestion: "Agregar Pregunta",
    surveysSubmitted: "Encuestas Enviadas",
    surveyDetail: "Detalles de la Encuesta",
    conditionStatus: "Estado de la Condición",
    conditionStatusDesc:
      "Los usuarios que cumplan con las condiciones serán elegibles para la encuesta automáticamente.",

    endSurvey: "Finalizar Encuesta",
    publishSurvey: "Publicar Encuesta",
    copy: "Copiar",
    view: "Ver",
    startDate: "Fecha de Inicio",
    endDate: "Fecha de Fin",
    chooseDate: "Elegir fecha",
    select: "Seleccionar",
    addSurveyQuestion: "Agregar Pregunta de la Encuesta",
    editSurveyQuestion: "Editar Pregunta de la Encuesta",
    questionScore: "Puntuación de la Pregunta",
    mandatory: "Obligatorio",
    yes: "Sí",
    no: "No",
    options: "Opciones",
    typeHere: "Escriba aquí",
    add: "Agregar",
    optionsHint:
      "Por favor, presione Enter para agregar una respuesta o haga clic en Agregar",
    surveyProgress: "Encuesta en progreso",
    allResponses: "Resumen de todas las respuestas",
    responseQuestion: "Respuestas por pregunta",
    dateSubmitted: "Fecha de Envío",
    answer: "Respuestas",
    totalScore: "Puntuación Total",
    score: "Puntuación",
    singleSelection: "Selección Única",
    multipleSelection: "Selección Múltiple",
    if: "Si",
    then: "entonces",
    noResponse: "Sin Respuesta",
    noSurveyFound: "No se encontraron Encuestas",
    createNewSurvey:
      'Por favor, cree una encuesta usando el botón "Crear Encuesta" de arriba',
    cannotPublish: "¡No se puede publicar una encuesta deshabilitada!",
    deleteSurveyWarn:
      "Estás seguro de que deseas eliminar la encuesta? Si la eliminas, todas las preguntas de la encuesta y las respuestas se eliminarán permanentemente.",
    noQuestionFound: "No se encontraron Preguntas",
    createQuestion:
      'Por favor, agregue una pregunta primero usando el botón "AGREGAR PREGUNTAS" de arriba',
    deleteQuestion: "Estás seguro de que deseas eliminar la pregunta?",
    applyChanges: "Cómo deseas aplicar estos cambios?",
    editFutureSurveys: "EDITAR SOLO ENCUESTAS FUTURAS",
    editLiveSurveyOnly: "EDITAR SOLO ENCUESTA ACTIVA",
    surveyIsLive:
      "Ten en cuenta que la encuesta está actualmente activa y editar una pregunta en este momento puede afectar las respuestas anteriores. Para evitar problemas, puedes considerar crear una copia de la encuesta para realizar cambios en las preguntas.",
    clickToCopy: "Haz clic aquí para crear una copia de la encuesta",
    applyChangesNow: "APLICAR CAMBIOS AHORA",
    copySurvey: "Copiar Encuesta",
    changeCopySurveyName:
      "Puedes cambiar el nombre de la versión copiada de la encuesta.",
    textField: "Campo de texto",
    textArea: "Área de texto",
    textFieldNumeric: "Campo numérico",
    radioButton: "Botón de radio",
    checkBoxes: "Casillas de verificación",
    dynamicFarmer: "Agricultor dinámico",
    dynamicGeofence: "Geocerca dinámica",
    dynamicCrop: "Cultivo dinámico",
    dynamicEquipment: "Equipos dinámicos",
    selectAllFiltered: "Seleccionar todo filtrado",

    downloadSurvey: "Descargar Encuesta",
    downloadQuestion: "Descargar Solo Preguntas",
    downloadResponse: "Descargar Todas las Respuestas",
    chooseFileFormat: "Elegir Formato de Archivo",
    surveyTitleLength: "El título de la encuesta debe tener menos de 100 caracteres",
    surveyDownloads: "Descargas de Encuestas",
  },
}